(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9412],{

/***/ 63624:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mail",
      function () {
        return __webpack_require__(11121);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 15171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4340);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15378);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61906);




const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
const RangePickerBox = (param)=>{
    let { className , rangePickerClassName , onClear , ...props } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative max-w-[400px] " + (className || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RangePicker, {
                placeholder: [
                    t("Start date"),
                    t("End date")
                ],
                allowClear: false,
                picker: "date",
                inputReadOnly: true,
                format: "YYYY-MM-DD",
                className: "h-[40px] text-[16px] w-full max-w-[400px] " + (rangePickerClassName || ""),
                ...props
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "text-[#D9D9D9] absolute z-[1] translate-y-[-50%] right-[36px] top-[50%] cursor-pointer hover:text-[#bfbfbf]",
                onClick: (e)=>{
                    e.stopPropagation();
                    onClear === null || onClear === void 0 ? void 0 : onClear(e);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RangePickerBox);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 11121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82017);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29061);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15378);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(57381);
/* harmony import */ var src_core_components_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21609);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var src_core_components_ios_verfiy_process__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4593);
/* harmony import */ var _src_api_dashboard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95629);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34745);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61906);
/* harmony import */ var src_components_RangePickerBox__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15171);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(90948);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74743);
/* harmony import */ var src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(31909);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  .ant-picker-input {// 包裹显示两个时间input的div样式\n    width:auto;\n  }\n  .ant-picker-input > input {// 显示两个时间的input样式\n    font-family: Poppins !important;\n    font-weight: 400 !important;\n    line-height: 24px !important;\n    font-size: 16px !important;\n    text-align: center;\n    text-overflow: clip !important;  /* 禁止使用省略号 */\n    overflow: visible !important;    /* 允许文本溢出 */\n  }\n  .ant-picker-input input[date-range="start"] {\n  width: var(--firstWidth) !important;\n  }\n  .ant-picker-input input[date-range="end"] {\n    width: var(--lastWidth) !important;\n  }\n  .ant-picker-input > input::placeholder {// 显示两个时间的placeholder样式（占位符\n    color:#ADADAD;\n  }\n  .ant-picker-suffix {// 框内icon样式\n    order:-1;\n    opacity:1 !important;\n    margin-right:11px;\n  }\n  '
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


















const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z;
const CustomRangePicker = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP)(RangePicker)(_templateObject());
const ScrollDiv = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP)("ul")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const Mail = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_12__/* .useTranslation */ .$G)("common") // 使用 i18next 进行国际化
    ;
    const readUsername = ()=>{
        var ref;
        return ((ref = JSON.parse(localStorage.getItem("DeviceUser"))) === null || ref === void 0 ? void 0 : ref.username) || "";
    };
    // 状态声明
    const [mailBoxes, setMailBoxes] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1) // 移动端显示层级
    ;
    const [boxes, setBoxes] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]) // 获取第一层数据
    ;
    // 获取第二层数据
    const [emailListPage, setEmailListPage] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1) // 当前邮件列表页码
    ;
    const [emailList, setEmailList] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]) // 当前显示的邮件列表
    ;
    const [emailListId, setMailListId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0) // 当前选中的邮件列表ID
    ;
    const [emailListTotal, setEmailListTotal] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0) // 邮件总数
    ;
    const [currentClickType, setCurrentClickType] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("") // 当前选中的文件夹名称
    ;
    // 获取第三层数据
    const [emailInfoId, setEmailInfoId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]) // 当前选中的邮件ID
    ;
    const [emailInfoContent, setEmailInfoContent] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]) // 当前邮件详细信息
    ;
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false) // 加载状态
    ;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useDispatch */ .I0)();
    const [antdSelectedDates, setAntdSelectedDates] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [selectedDateIndex, setSelectedDateIndex] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    //筛选过的消息列表
    const [dateMessageList, setDateMessageList] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true) //正在加载获取数据
    ;
    // 将文件夹数据转换为嵌套结构
    const convertToNestedStructure = (inputData)=>{
        const result = [];
        inputData.forEach((folder)=>{
            const pathComponents = folder.displayName.split("/");
            let currentLevel = result;
            pathComponents.forEach((component)=>{
                let existingFolder = currentLevel.find((item)=>item.displayName === component);
                if (!existingFolder) {
                    existingFolder = {
                        displayName: component,
                        identifier: folder.identifier,
                        messageCount: folder.messageCount,
                        children: []
                    };
                    currentLevel.push(existingFolder);
                }
                currentLevel = existingFolder.children;
            });
        });
        return result;
    };
    // 渲染嵌套的文件夹结构
    const renderNested = function(folders) /*#__PURE__*/ {
        let level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
            style: {
                paddingLeft: "".concat(level * 4, "px"),
                listStyleType: "none"
            },
            children: folders.map((folder)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                    style: {
                        width: "100%",
                        height: "34px",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "21px",
                        marginBottom: "10px",
                        cursor: "pointer",
                        paddingLeft: "".concat(level * 1, "px"),
                        color: "rgba(0, 0, 0, 0.88)",
                        borderRadius: "6px",
                        position: "relative",
                        paddingTop: "7px",
                        paddingLeft: "10px",
                        background: emailListId === folder.identifier ? "#E7E7E9" : "",
                        borderBottom: window.innerWidth >= 1000 ? "1px solid #E4E4E6 !important" : ""
                    },
                    onClick: (e)=>getMailSummary(e, folder),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                            src: emailListId === folder.identifier ? "/images/mail/mail-folder1.svg" : "/images/mail/mail-folder2.svg",
                            width: 20,
                            height: 20,
                            alt: "img",
                            priority: true,
                            style: {
                                display: "inline-block",
                                verticalAlign: "middle"
                            }
                        }),
                        "\xa0\xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: "",
                            children: folder.displayName
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            style: {
                                position: "absolute",
                                right: "4px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                icon: "material-symbols:chevron-right-rounded",
                                color: "#C5C5C7"
                            })
                        }),
                        folder.children && renderNested(folder.children, level + 1)
                    ]
                }, folder.identifier))
        });
    };
    // 按「当前文件夹 + 当前日期区间」重新拉取邮件列表（日期由接口筛选）
    const reloadMailList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(async (range)=>{
        if (!emailListId) return;
        try {
            const result = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_9__/* .getAllDashboard */ .gP)({
                username: readUsername(),
                params: {
                    category: "MAIL_SESSION_SUMMARY",
                    rid: String(emailListId),
                    offset: 0,
                    limit: 1000,
                    ...(0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_15__/* .buildTimeParams */ .W2)(range)
                }
            });
            setEmailListTotal(result.data.totalCount);
            const map = (result.data.contents || []).map((row)=>({
                    ...row,
                    date: dayjs__WEBPACK_IMPORTED_MODULE_5___default()(row.date).format("YYYY-MM-DD"),
                    name: row.from ? row.from[0].split("<")[0].trim().replace(/"/g, "") : ""
                }));
            setDateMessageList(map);
            setEmailList(map);
        } catch (error) {
            ;
        }
    }, [
        emailListId
    ]);
    //选择日期范围
    const handleDateChange = (dates, dateStrings)=>{
        const picked = dates && dates.length === 2 ? dates : [];
        setAntdSelectedDates(picked);
        setSelectedDateIndex(picked.length === 2 ? 2 : 1);
        reloadMailList(picked);
    };
    // 获取邮件文件夹
    const getBoxes = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(async ()=>{
        try {
            const result = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_9__/* .getAllDashboard */ .gP)({
                username: readUsername(),
                params: {
                    category: "MAIL_FOLDER",
                    offset: 0,
                    limit: 100
                }
            });
            const data = convertToNestedStructure(result.data.contents || []);
            setBoxes(data);
        } catch (error) {
            ;
        }
        setIsLoading(false);
    }, []);
    // 获取邮件摘要信息
    const getMailSummary = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(async (e, row, mode)=>{
        try {
            if (!mode) {
                setMailBoxes(2) // 切换到邮件列表视图
                ;
            }
            //静止冒泡
            e.stopPropagation();
            const result = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_9__/* .getAllDashboard */ .gP)({
                username: readUsername(),
                params: {
                    category: "MAIL_SESSION_SUMMARY",
                    rid: String(row.identifier),
                    offset: (emailListPage - 1) * 10,
                    limit: 1000,
                    // 日期筛选走接口：带 startTime/endTime 时服务端按时间过滤
                    ...(0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_15__/* .buildTimeParams */ .W2)(antdSelectedDates)
                }
            });
            setEmailListTotal(result.data.totalCount);
            setCurrentClickType(row.displayName);
            setMailListId(row.identifier);
            setEmailListPage(1);
            localStorage.setItem("icloudMailListId", row.identifier);
            if (result.data.contents) {
                const map = result.data.contents.map((row)=>({
                        ...row,
                        date: dayjs__WEBPACK_IMPORTED_MODULE_5___default()(row.date).format("YYYY-MM-DD"),
                        name: row.from ? row.from[0].split("<")[0].trim().replace(/"/g, "") : "",
                        content: row.content ? row.content[0].trim() : ""
                    }));
                setDateMessageList(map);
                setEmailList(map);
            } else {
                setEmailList([]);
            }
        } catch (error) {
            ;
        }
    }, [
        emailListPage
    ]);
    // 获取邮件详细信息
    const getEmailInfo = async (id)=>{
        try {
            // 在移动端进入第三层数据
            setMailBoxes(3);
            // 写入id
            setEmailInfoId(id);
            const result = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_9__/* .getAllDashboard */ .gP)({
                username: readUsername(),
                params: {
                    category: "MAIL_SESSION",
                    rid: String(id)
                }
            });
            const contents = result.data.contents;
            if (contents && contents.mails) {
                const updatedMails = await Promise.all(contents.mails.map(async (mail)=>{
                    const contentText = await axios__WEBPACK_IMPORTED_MODULE_18__/* ["default"].get */ .Z.get("https://cos.spyx.com/".concat(mail.url));
                    const tempDiv = document.createElement("div");
                    tempDiv.innerHTML = contentText.data;
                    [
                        ...tempDiv.getElementsByTagName("style")
                    ].forEach((styleTag)=>styleTag.parentNode.removeChild(styleTag));
                    return {
                        ...mail,
                        fromName: mail.from[0].split("<")[0].trim().replace(/"/g, ""),
                        toName: mail.to[0].split("<")[0].trim().replace(/"/g, ""),
                        time: dayjs__WEBPACK_IMPORTED_MODULE_5___default()(mail.date).format("YYYY-MM-DD"),
                        info: tempDiv.innerHTML
                    };
                }));
                setEmailInfoContent(updatedMails);
            }
        } catch (error) {
            ;
        }
    };
    // 处理滚动事件以加载更多邮件
    const handleScroll = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        const ulElement = document.getElementById("email-list");
        if (ulElement && !loading) {
            const isAtBottom = ulElement.scrollHeight - ulElement.scrollTop <= ulElement.clientHeight + 1;
            if (isAtBottom) {
                setLoading(true);
                setEmailListPage((prevPage)=>prevPage + 1);
            }
        }
    }, [
        loading
    ]);
    // 添加滚动事件监听器
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const emailListElement = document.getElementById("email-list");
        if (emailListElement) {
            emailListElement.addEventListener("scroll", handleScroll);
            return ()=>emailListElement.removeEventListener("scroll", handleScroll);
        }
    }, [
        handleScroll
    ]);
    // 加载更多邮件数据
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const loadMoreData = async ()=>{
            try {
                if (emailListTotal === emailList.length) {
                    setLoading(false);
                    return;
                }
                const result = await (0,_src_api_dashboard__WEBPACK_IMPORTED_MODULE_9__/* .getAllDashboard */ .gP)({
                    username: readUsername(),
                    params: {
                        category: "MAIL_SESSION_SUMMARY",
                        rid: String(emailListId),
                        offset: (emailListPage - 1) * 10,
                        limit: 1000,
                        ...(0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_15__/* .buildTimeParams */ .W2)(antdSelectedDates)
                    }
                });
                setEmailListTotal(result.data.totalCount);
                if (result.data.contents) {
                    const map = result.data.contents.map((row)=>({
                            ...row,
                            date: dayjs__WEBPACK_IMPORTED_MODULE_5___default()(row.date).format("YYYY-MM-DD"),
                            name: row.from ? row.from[0].split("<")[0].trim().replace(/"/g, "") : ""
                        }));
                    setDateMessageList(map);
                    // 没选日期时必须原样保留（原来会把 startTime 算成 undefined，导致翻页永远追加不到数据）
                    const { startTime , endTime  } = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_15__/* .buildTimeParams */ .W2)(antdSelectedDates);
                    const filteredMap = startTime == null || endTime == null ? map : map.filter((item)=>{
                        const itemTime = (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_15__/* .toMillis */ .eq)(item.date);
                        return itemTime >= startTime && itemTime <= endTime;
                    });
                    setEmailList((prevList)=>prevList.concat(filteredMap));
                }
                setLoading(false);
            } catch (error) {
                ;
                setLoading(false);
            }
        };
        loadMoreData();
    }, [
        emailListPage,
        emailListId
    ]);
    // 根据日期范围更新邮件列表
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (boxes.length > 0) {
            const currentFolder = boxes.find((folder)=>folder.identifier === emailListId);
            if (currentFolder) {
                getMailSummary({
                    stopPropagation: ()=>{}
                }, currentFolder, true);
            }
        }
    }, [
        boxes,
        emailListId,
        getMailSummary
    ]);
    // 设备切换时重置邮件视图并重新拉数
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_3__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        setMailBoxes(1);
        setBoxes([]);
        setEmailListPage(1);
        setEmailList([]);
        setMailListId(0);
        setEmailListTotal(0);
        setCurrentClickType("");
        setEmailInfoId([]);
        setEmailInfoContent([]);
        setDateMessageList([]);
        setIsLoading(true);
        getBoxes();
    }, [
        getBoxes
    ]));
    // 设置当前选项卡
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_11__/* .setCurrentTab */ .Lw)(t("Mail")));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_11__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch
    ]);
    // 获取今天的日期
    const today = dayjs__WEBPACK_IMPORTED_MODULE_5___default()().format("YYYY-MM-DD");
    // 获取七天前的日期
    const sevenDaysAgo = dayjs__WEBPACK_IMPORTED_MODULE_5___default()().subtract(7, "day").format("YYYY-MM-DD");
    // 获取最宽日期选择器占位符宽度
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        // 开始时间&结束时间
        let firstDate = "0000-00-00";
        let lastDate = "0000-00-00";
        // 开始时间宽度&结束时间宽度
        let firstWidth = 0;
        let lastWidth = 0;
        const span = document.createElement("span");
        span.style.setProperty("font-family", "Poppins", "important");
        span.style.setProperty("font-size", "16px", "important");
        span.style.setProperty("font-weight", "400", "important");
        span.style.setProperty("line-height", "24px", "important");
        span.style.visibility = "hidden";
        span.innerText = firstDate;
        // 获取第一个占位符宽度
        document.body.appendChild(span);
        firstWidth = span.offsetWidth;
        document.body.removeChild(span);
        // 获取第二个占位符宽度
        span.innerText = lastDate;
        document.body.appendChild(span);
        lastWidth = span.offsetWidth;
        document.body.removeChild(span);
        // 插入至html标签样式中用于调用
        document.documentElement.style.setProperty("--firstWidth", "".concat(firstWidth, "px"));
        document.documentElement.style.setProperty("--lastWidth", "".concat(lastWidth, "px"));
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                    name: "format-detection",
                    content: "telephone=no"
                })
            }),
            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "relative bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "relative flex Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] rounded-[10px] smj:hidden",
                        style: {
                            boxShadow: "0px 2px 10px 0px rgba(76, 78, 100, 0.22)"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                style: {
                                    width: "20%",
                                    height: "100%",
                                    background: "#F9F9FF",
                                    borderRight: "1px solid #D8D8DA",
                                    padding: "10px",
                                    overflow: "auto",
                                    paddingRight: "0px",
                                    position: "relative"
                                },
                                children: [
                                    renderNested(boxes),
                                    boxes.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none",
                                        children: [
                                            t("It appears theres no data to show here yet"),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                            t("If data exists it may take up to 1 hour to download and appear"),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                            t("We suggest checking back in a little while")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                style: {
                                    width: "25%",
                                    height: "100%",
                                    background: "#fff",
                                    borderRight: "1px solid #D8D8DA",
                                    paddingLeft: "10px",
                                    paddingright: "10px",
                                    paddingTop: "8px"
                                },
                                className: "Hsm:hidden",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                        style: {
                                            marginLeft: "8px",
                                            fontWeight: "600",
                                            fontSize: "18px",
                                            lineHeight: "27px",
                                            paddingLeft: "8px",
                                            color: "#000000"
                                        },
                                        children: currentClickType
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        style: {
                                            marginLeft: "8px",
                                            color: "#A9A9A9",
                                            fontWeight: "400",
                                            fontSize: "12px",
                                            lineHeight: "18px",
                                            paddingLeft: "8px"
                                        },
                                        children: [
                                            emailListTotal,
                                            " ",
                                            t("Email")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                        id: "email-list",
                                        style: {
                                            marginTop: "22px",
                                            height: "calc(100% - 80px)",
                                            overflowY: "auto",
                                            paddingright: 0
                                        },
                                        children: emailList.map((row, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                style: {
                                                    borderBottom: "1px solid #E4E4E6",
                                                    padding: "10px 4px",
                                                    cursor: "pointer",
                                                    borderRadius: emailInfoId === row.id ? "6px" : "0px",
                                                    background: emailInfoId === row.id ? "#E4E4E6" : ""
                                                },
                                                onClick: ()=>getEmailInfo(row.id),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        style: {
                                                            paddingLeft: "3px",
                                                            display: "flex",
                                                            justifyContent: "space-between"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                style: {
                                                                    fontWeight: "600",
                                                                    fontSize: "16px",
                                                                    lineHeight: "24px",
                                                                    color: "#000000"
                                                                },
                                                                children: row.name
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                style: {
                                                                    color: "#808080",
                                                                    fontSize: "12px",
                                                                    paddingRight: "3px"
                                                                },
                                                                children: row.date
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            paddingLeft: "3px",
                                                            fontWeight: "400",
                                                            fontSize: "13px",
                                                            lineHeight: "19.5px",
                                                            color: "#222222"
                                                        },
                                                        children: row.name
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            paddingLeft: "3px",
                                                            color: "#808080",
                                                            fontSize: "13px",
                                                            fontWeight: "400",
                                                            wordWrap: "break-word",
                                                            lineHeight: "19px",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            display: "-webkit-box",
                                                            WebkitBoxOrient: "vertical",
                                                            WebkitLineClamp: "2"
                                                        },
                                                        children: row.subject
                                                    })
                                                ]
                                            }, i))
                                    }),
                                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                style: {
                                    width: "55%",
                                    background: "#fff",
                                    overflow: "auto"
                                },
                                className: "Hsm:hidden",
                                children: emailInfoContent.map((row, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                style: {
                                                    height: "96px",
                                                    borderBottom: "1px solid #E4E4E6",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            marginLeft: "36px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                style: {
                                                                    width: "40px",
                                                                    height: "40px",
                                                                    background: "#A6A6AA",
                                                                    borderRadius: "50%",
                                                                    textAlign: "center",
                                                                    lineHeight: "40px",
                                                                    fontWeight: "600",
                                                                    fontSize: "20px",
                                                                    color: "#fff",
                                                                    marginRight: "14px"
                                                                },
                                                                children: row.fromName.substr(0, 1)
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                        style: {
                                                                            fontWeight: "600",
                                                                            fontSize: "16px",
                                                                            lineHeight: "24px"
                                                                        },
                                                                        children: row.fromName
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                        style: {
                                                                            fontWeight: "600",
                                                                            fontSize: "12px",
                                                                            lineHeight: "18px"
                                                                        },
                                                                        children: row.getAllDashboard
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                                        style: {
                                                                            fontSize: "14px"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                                                children: [
                                                                                    t("Receipt"),
                                                                                    ":"
                                                                                ]
                                                                            }),
                                                                            " ",
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                                style: {
                                                                                    color: "rgba(0, 0, 0, 0.48)"
                                                                                },
                                                                                children: row.toName
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            color: "rgba(0, 0, 0, 0.56)",
                                                            fontSize: "14PX",
                                                            marginRight: "36px"
                                                        },
                                                        children: row.time
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                style: {
                                                    overflow: "auto"
                                                },
                                                dangerouslySetInnerHTML: {
                                                    __html: row.info
                                                }
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "relative bg-[#FFF] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] h-[calc(var(--vh2)*100-90px)] smj:!h-[calc(var(--vh2)*100-86px)] m-auto hidden smj:flex flex-col",
                        children: [
                            mailBoxes === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                style: {
                                    width: "100%",
                                    height: "100%",
                                    background: "#FFF",
                                    padding: "17px 0px 10px 16px",
                                    overflow: "auto"
                                },
                                className: "rounded-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "text-[18px] leading-[27px] font-[600]",
                                        children: "iCloud"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                        children: boxes.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                className: "flex items-center",
                                                onClick: (e)=>getMailSummary(e, item),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        src: emailListId === item.identifier ? "/images/mail/mail-folder1.svg" : "/images/mail/mail-folder2.svg",
                                                        width: 20,
                                                        height: 20,
                                                        alt: "img",
                                                        priority: true,
                                                        className: "inline-block align-middle"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "w-full flex items-center ml-[14.5px] py-4 [border-bottom:0.5px_solid_#E5E7EB]",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                className: "text-[16px] font-[500] leading-[24px]",
                                                                children: item.displayName
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                className: "flex items-center absolute right-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                        className: "text-[14px] font-[400] leading-[21px] text-[#BABABE]",
                                                                        children: item.messageCount > 0 && item.messageCount
                                                                    }),
                                                                    "\xa0",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                        icon: "material-symbols:chevron-right-rounded",
                                                                        color: "#C5C5C7"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, item.identifier))
                                    })
                                ]
                            }),
                            mailBoxes === 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    color: "#000000",
                                                    margin: "auto"
                                                },
                                                className: "py-[21px] w-[90%]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        icon: "ion:chevron-back",
                                                        onClick: ()=>setMailBoxes(1)
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        style: {
                                                            textAlign: "center",
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            fontWeight: "500",
                                                            margin: "auto"
                                                        },
                                                        children: currentClickType
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "w-[24px] h-[24px]"
                                                    })
                                                ]
                                            }),
                                            emailList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "w-full px-[15px] mb-2",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomRangePicker, {
                                                        format: "YYYY-MM-DD" // 左右两边显示的日期格式
                                                        ,
                                                        placeholder: [
                                                            sevenDaysAgo,
                                                            today
                                                        ],
                                                        separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            className: "text-[#ADADAD]",
                                                            children: "~"
                                                        }),
                                                        suffixIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                            src: "/images/calls/calendar.svg",
                                                            alt: "calendar",
                                                            width: 18,
                                                            height: 18
                                                        }),
                                                        className: "w-full h-[40px] bg-[#F8F8F8]",
                                                        inputReadOnly: true,
                                                        // allowClear={false} // 清除按钮是否显示
                                                        onChange: handleDateChange
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollDiv, {
                                        id: "email-list",
                                        className: "w-full px-[15px] overflow-auto",
                                        children: emailList.map((row, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                className: "w-full py-[8px]",
                                                style: {
                                                    borderBottom: "1px solid #E5E7EB",
                                                    cursor: "pointer"
                                                },
                                                onClick: ()=>getEmailInfo(row.id),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        style: {
                                                            paddingLeft: "3px",
                                                            display: "flex",
                                                            justifyContent: "space-between"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                style: {
                                                                    fontWeight: "600",
                                                                    fontSize: "16px",
                                                                    lineHeight: "24px",
                                                                    color: "#000000"
                                                                },
                                                                children: row.name
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                style: {
                                                                    fontWeight: "400",
                                                                    color: "#808080",
                                                                    fontSize: "12px",
                                                                    lineHeight: "18px",
                                                                    paddingRight: "3px"
                                                                },
                                                                children: dayjs__WEBPACK_IMPORTED_MODULE_5___default()(row.date).format("YYYY/MM/DD")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            fontWeight: "400",
                                                            paddingLeft: "3px",
                                                            fontSize: "13px",
                                                            lineHeight: "19.5px",
                                                            color: "#222222"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                            children: row.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            paddingLeft: "3px",
                                                            color: "#808080",
                                                            fontSize: "13px",
                                                            fontWeight: "400",
                                                            wordWrap: "break-word",
                                                            lineHeight: "19px",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            display: "-webkit-box",
                                                            WebkitBoxOrient: "vertical",
                                                            WebkitLineClamp: "2"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                            children: row.subject
                                                        })
                                                    })
                                                ]
                                            }, i))
                                    }),
                                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {})
                                    })
                                ]
                            }),
                            mailBoxes === 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: emailInfoContent.map((row, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "h-[calc(var(--vh2)*100-90px)] smj:!h-[calc(var(--vh2)*100-86px)] flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    color: "#000000",
                                                    margin: "auto",
                                                    paddingLeft: "16px"
                                                },
                                                className: "py-[21px] w-[100%]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        icon: "ion:chevron-back",
                                                        onClick: ()=>setMailBoxes(2)
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        style: {
                                                            textAlign: "center",
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            fontWeight: "600",
                                                            margin: "auto"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "w-[24px] h-[24px]"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                style: {
                                                    width: "100%",
                                                    margin: "auto",
                                                    height: "auto",
                                                    borderBottom: "1px solid #E4E4E6",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    paddingLeft: "16px",
                                                    paddingBottom: "12px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        style: {
                                                            width: "35px",
                                                            height: "35px",
                                                            background: "linear-gradient(180deg, #A5AAB6 0%, #868A93 100%)",
                                                            borderRadius: "50%",
                                                            textAlign: "center",
                                                            lineHeight: "24px",
                                                            fontWeight: "500",
                                                            fontSize: "16px",
                                                            color: "#fff",
                                                            marginRight: "14px",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        },
                                                        children: row.fromName.split(" ").map((word)=>word[0]).join("")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "flex-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                style: {
                                                                    justifyContent: "space-between",
                                                                    display: "flex",
                                                                    alignItems: "start"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                        style: {
                                                                            fontWeight: "600",
                                                                            fontSize: "16px",
                                                                            lineHeight: "24px",
                                                                            maxWidth: "65%",
                                                                            wordBreak: "break-all"
                                                                        },
                                                                        children: row.fromName
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                        style: {
                                                                            color: "rgba(0, 0, 0, 0.56)",
                                                                            fontSize: "14PX",
                                                                            lineHeight: "21px",
                                                                            paddingRight: "12px"
                                                                        },
                                                                        children: dayjs__WEBPACK_IMPORTED_MODULE_5___default()(row.time).format("YYYY/MM/DD")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                style: {
                                                                    fontSize: "14px",
                                                                    lineHeight: "21px",
                                                                    fontWeight: "400",
                                                                    display: "flex",
                                                                    alignItems: "start"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                                        children: [
                                                                            t("Receipt"),
                                                                            ":"
                                                                        ]
                                                                    }),
                                                                    "\xa0",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                                        className: "text-[#959595] max-w-[55%] break-all",
                                                                        children: [
                                                                            row.toName,
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                                                src: "/images/mail/mailunion.svg",
                                                                                width: 7,
                                                                                height: 7,
                                                                                className: "inline-block ml-2"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "flex-1 overflow-auto rounded-[10px]",
                                                dangerouslySetInnerHTML: {
                                                    __html: row.info
                                                }
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    boxes.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none smjs:hidden",
                        children: [
                            t("It appears theres no data to show here yet"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            t("If data exists it may take up to 1 hour to download and appear"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            t("We suggest checking back in a little while")
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Mail);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,1033,8914,3368,1675,5378,2862,770,210,2586,6456,621,9145,9965,4593,9774,2888,179], function() { return __webpack_exec__(63624); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);